import React from "react";
import { connect } from "react-redux";
import LexicalEditor from "../../../shared/components/TextEditor/Lexical/LexicalEditor";

const TermsEditor = ({ details, updateEditorState, editView }) => {
	if (!editView && !details) {
		return null;
	}

	return (
		<div className={`w-100`}>
			<LexicalEditor
				editorState={details}
				scrollerClasses="page-content--345-max"
				convertFromHTML={true}
				hideTableAndImage={true}
				onChange={updateEditorState}
				editable={editView}
				wrapperEditorClasses={`${
					editView ? "bg-n000 border-radius-regular" : ""
				}`}
			/>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const {
		isForOrder = false,
		isInputRequirements = false,
		isForOrderInputRequirement = false,
	} = ownProps;
	let details = state.getIn([
		"administration",
		"termsAndConditions",
		"details",
	]);

	if (isInputRequirements) {
		// "Input requirements" legal doc (review 2026-06-09 §6) — same editor
		// mechanics as T&C, different administration slice.
		details = state.getIn(["administration", "inputRequirements", "details"]);
	}

	if (isForOrder) {
		details = state.getIn(["project", "project", "termsAndConditions"]);
	}

	if (isForOrderInputRequirement) {
		// Order-level "Input requirements" stored on the order itself (mirrors the
		// order T&C above; same editor mechanics).
		details = state.getIn(["project", "project", "inputRequirement"]);
	}
	return {
		details,
	};
};

export default connect(mapStateToProps, {})(TermsEditor);
